// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sSY7j","col":"styles_col__2xA5Q"};